export default "__VITE_ASSET__CR40ggrx__"